import '../styles/style.less'
import '@pingcap/tidb-dashboard-lib/dist/index.css'

import './main'

import '../styles/override.less'
